import React from 'react';

const PageHeader = ({ title, subtitle, children }) => {
  return (
    <div className="sm:mx-2 py-4 mb-4 border-b border-content/40 border-dashed">
      <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-0 items-start">
        <div>
          <h1 className="text-xl font-bold text-primary">{title}</h1>
          <p className="text-sm text-muted mt-1">{subtitle}</p>
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
